import { Component } from '@angular/core';

@Component({
  selector: 'ng-eva',
  styleUrls: ['./eva.components.scss'],
  templateUrl: './eva.component.html',
})
export class NgdEvaComponent {}
